// dependencies
import React from "react";

import Spinner from "../../../../../../components/Spinner";
// components
import Text from "../../../../../../components/Text";
import { CardBody, CardHeader } from "../../../../components/Card";

// hooks
import { useCurrentSurveyPeriodData } from "../../../../../../api/hooks";

import css from "../shared.module.scss";

const parsePercent = (rate: number) => {
	return Number.isInteger(rate) ? rate : rate.toFixed(0);
};

const CurrentSurveryPeriodKPI = () => {
	const { data, isLoading } = useCurrentSurveyPeriodData();
	const currentSurveyData = data?.data[0] ? data?.data[0] : null;
	const dayRemaining = currentSurveyData?.days_remaining || 0;
	const dayRemainingText = dayRemaining === 1 ? "Day Remaining" : "Days Remaining";

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="regular">
							Current Survey{" "}
							<Text element="span" size="paragraph-2" weight="semi-bold">
								Period
							</Text>
						</Text>
					</span>
				}
				info="This chart displays the status and participation of the current survey."
			/>
			<CardBody>
				{isLoading && (
					<div className={css.spinner}>
						<Spinner />
					</div>
				)}
				{!isLoading && (
					<div className={css.cardBody}>
						<div className={css.leftContent}>
							<p className={css.largeText}>{dayRemaining}</p>
							<Text size="caption" weight="semi-bold" className={css.subText}>
								{dayRemainingText}
							</Text>
						</div>
						<div>
							<Text size="caption" weight="semi-bold" className={css.dataText}>
								Participation Rate: {parsePercent(currentSurveyData?.participation_rate || 0)}%
							</Text>
							<Text size="caption" weight="semi-bold" className={css.dataText}>
								Questions Answered: {parsePercent(currentSurveyData?.percent_questions_answered || 0)}%
							</Text>
							<Text size="caption" weight="semi-bold" className={css.dataText}>
								Participants: {currentSurveyData?.num_participants || 0} (
								{currentSurveyData?.total_survey || 0} Total)
							</Text>
						</div>
					</div>
				)}
			</CardBody>
		</>
	);
};

export default CurrentSurveryPeriodKPI;
